import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

import {
  extractLocaleFromQuery,
  getApplicationType,
  getAssetPathPrefix,
  getBackendPrefix,
  getBaseName,
  getRouteType,
} from './helpers/helper';

export interface QueryParameter {
  key: string;
  value: (string | number)[];
}

export interface BaseState {
  language: string;
  country: string;
  backendPrefix: string;
  assetPathPrefix: string;
  routeType: string;
  applicationType: string;
  baseName: string;
  parameterPrefix: string;
  parameters: QueryParameter[];
}

const location = window.location;
const applicationType = getApplicationType(location.pathname, location.hostname);

const localeInformation = extractLocaleFromQuery(applicationType, location.hash, location.pathname);
const backendPrefix = getBackendPrefix(localeInformation.country, localeInformation.language);
export const initialState: BaseState = {
  language: localeInformation.language,
  country: localeInformation.country,
  backendPrefix: backendPrefix,
  assetPathPrefix: getAssetPathPrefix(applicationType, backendPrefix),
  routeType: getRouteType(),
  applicationType: applicationType,
  baseName: getBaseName(applicationType, localeInformation.country, localeInformation.language),
  parameterPrefix: '',
  parameters: [],
};

export const baseSlice = createSlice({
  name: 'base',
  initialState,
  reducers: {},
});

export const selectBackendPathWithoutLeadingSlash = (state: RootState): string => state.base.backendPrefix.substring(1);

export default baseSlice.reducer;
